import { useCallback, useState } from 'react';
import { Input, LabeledContainer } from '@schibsted-svp/react-ui';

import type { ChangeEvent, FC } from 'react';

type Props = {
  onFilterChange: (value: string) => void;
};

const TableFilter: FC<Props> = ({ onFilterChange }) => {
  const [filter, setFilter] = useState('');

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value || '';

      setFilter(value);
      onFilterChange(value);
    },
    [setFilter, onFilterChange]
  );

  return (
    <LabeledContainer label="Filter">
      <Input onChange={onChange} value={filter} />
    </LabeledContainer>
  );
};

export { TableFilter };
